import React, { Component } from "react";
import styled from "styled-components";

import { AdvanceSlideOnType } from "common/constants";

import {
    Mouse as MouseIcon,
    MusicNote as MusicNoteIcon
} from "@material-ui/icons";

import { BoxButton } from "js/react/views/AnimationPanel/Components/BoxButton";
import { DurationControl } from "js/react/views/AnimationPanel/Components/DurationControl";

const Container = styled.div`
    padding: 20px;

    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
`;

const Header = styled.span`
    font-weight: 600;
    font-size: 15px;
    line-height: 19px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #666666;
    margin-bottom: 20px;
`;

const AdvanceTypeSelectContainer = styled.div`
    width: 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

function AdvanceTypeSelect({ currentType, currentDelay, availableTypes, onChange }) {
    return (
        <AdvanceTypeSelectContainer>
            <BoxButton
                selected={currentType === AdvanceSlideOnType.CLICK}
                onClick={() => onChange({ advanceOn: AdvanceSlideOnType.CLICK })}
                disabled={!availableTypes.includes(AdvanceSlideOnType.CLICK)}
                IconType={MouseIcon}
                backgroundColor="#eeeeee"
                selectedBackgroundColor="#dbe9f0"
                labelText={"on click"}
                width={"calc((100% - 10px) / 3)"}
                height={"58px"}
                containerStyle={{ marginRight: "5px" }}
            />
            <BoxButton
                selected={currentType === AdvanceSlideOnType.DELAY}
                onClick={() => onChange({ advanceOn: AdvanceSlideOnType.DELAY })}
                disabled={!availableTypes.includes(AdvanceSlideOnType.DELAY)}
                CustomControl={<DurationControl value={currentDelay} onChange={duration => onChange({ advanceDelay: duration })} />}
                backgroundColor="#eeeeee"
                selectedBackgroundColor="#dbe9f0"
                labelText={"timed"}
                width={"calc((100% - 10px) / 3)"}
                height={"58px"}
                containerStyle={{ marginRight: "5px" }}
            />
            <BoxButton
                selected={currentType === AdvanceSlideOnType.AUDIO}
                onClick={() => onChange({ advanceOn: AdvanceSlideOnType.AUDIO })}
                disabled={!availableTypes.includes(AdvanceSlideOnType.AUDIO)}
                IconType={MusicNoteIcon}
                backgroundColor="#eeeeee"
                selectedBackgroundColor="#dbe9f0"
                labelText={"after audio"}
                width={"calc((100% - 10px) / 3)"}
                height={"58px"}
            />
        </AdvanceTypeSelectContainer>
    );
}
export function SlideOptionsDialog({
    advanceOn,
    advanceDelay,
    hasAudioAsset,
    updateSlide
}) {
    const availableAdvanceOnTypes = Object.values(AdvanceSlideOnType)
        .filter(type => (type === AdvanceSlideOnType.AUDIO && hasAudioAsset) || type !== AdvanceSlideOnType.AUDIO);

    return (
        <Container>
            <Header>Play next slide</Header>
            <AdvanceTypeSelect
                currentType={advanceOn}
                availableTypes={availableAdvanceOnTypes}
                currentDelay={advanceDelay}
                onChange={({ advanceOn, advanceDelay }) => updateSlide({ advanceOn, advanceDelay })}
            />
        </Container>
    );
}
